<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import {
  ShieldCheck,
  Briefcase,
  Crown,
  ClipboardList,
  HardHat,
  Wrench,
  Compass,
  Building2,
  User,
} from 'lucide-vue-next';
import { cn } from '../../design-system/utils';

interface Props {
  role: string;
  size?: 'sm' | 'md';
}

const props = withDefaults(defineProps<Props>(), { size: 'md' });
const { t, te } = useI18n();

const iconMap: Record<string, any> = {
  super_admin_sds: ShieldCheck,
  admin:           Crown,
  direction:       Briefcase,
  conducteur:      ClipboardList,
  chef:            HardHat,
  compagnon:       Wrench,
  architecte:      Compass,
  client_final:    Building2,
};

const icon = computed(() => iconMap[props.role] || User);

const label = computed(() => {
  const key = `roles.${props.role}`;
  return te(key) ? t(key) : props.role;
});

const ariaLabel = computed(() => t('roles.aria_label', { role: label.value }));

const classes = computed(() =>
  cn(
    'inline-flex items-center gap-1.5 rounded-full whitespace-nowrap font-medium',
    'bg-elevated border border-border text-text-secondary',
    props.size === 'sm' ? 'h-5 px-2 text-xs gap-1' : 'h-6 px-2.5 text-xs',
  ),
);
</script>

<template>
  <span :class="classes" :aria-label="ariaLabel">
    <component :is="icon" :size="size === 'sm' ? 10 : 12" aria-hidden="true" />
    {{ label }}
  </span>
</template>
